<pinch-zoom
  [minScale]="1"
  [disableZoomControl]="'disable'"
  class="both zoom-container translate-top-most"
  [backgroundColor]="'rgba(0, 0, 0, 0)'"
  [ngStyle]="{
    width: scaleR.offsetLeft * 2 + 720 * scaleR.scaleX + 'px',
    height: scaleR.offsetTop * 2 + 1280 * scaleR.scaleX + 'px',
    top: 0 * scaleR.scaleX + 'px',
    left: 0 * scaleR.scaleX + 'px'
  }"
>
  <div
    class="help-container translate-top-most"
    (click)="buttonClick('close')"
  ></div>
  <img
    [resizeDom]="helpContentStage"
    class="both tnimage settings1 pointernone translate-top-most"
    src="assets/images/help/fcb/common/bg_fcb_tutorials_00_Gold_Underlay@2x.webp?t={{
      version
    }}"
  />
  <img
    [resizeDom]="helpContentStage"
    class="both tnimage settings1 pointernone translate-top-most"
    src="assets/images/help/fcb/{{ language }}/{{ language }}_{{
      tutorialContent['TN_image_' + tutorialCount]
    }}?t={{ version }}"
  />
  <div
    class="translate-top-most"
    [resizeDom]="settingsContentStage"
    [ngStyle]="{
      visibility: display == 1 && tutorialCount == 0 ? 'visible' : 'hidden'
    }"
  >
    <div class="both tutorialbutton1 tutorial" (click)="tutorialClick(1)"></div>
    <div class="both tutorialbutton2 tutorial" (click)="tutorialClick(2)"></div>
    <div class="both tutorialbutton3 tutorial" (click)="tutorialClick(3)"></div>
    <div class="both tutorialbutton4 tutorial" (click)="tutorialClick(4)"></div>
    <div class="both tutorialbutton5 tutorial" (click)="tutorialClick(5)"></div>
    <div class="both tutorialbutton6 tutorial" (click)="tutorialClick(6)"></div>
    <div class="both tutorialbutton7 tutorial" (click)="tutorialClick(7)"></div>
    <div class="both tutorialbutton8 tutorial" (click)="tutorialClick(9)"></div>
    <div class="both tutorialbutton9 tutorial" (click)="tutorialClick(8)"></div>
    <div
      class="both tutorialbutton10 tutorial"
      (click)="tutorialClick(10)"
    ></div>
    <div
      class="both tutorialbutton11 tutorial"
      (click)="tutorialClick(11)"
    ></div>
    <div
      class="both tutorialbutton12 tutorial"
      (click)="tutorialClick(12)"
    ></div>
    <div
      class="both tutorialbutton13 tutorial"
      (click)="tutorialClick(13)"
    ></div>
    <div
      class="both tutorialbutton14 tutorial"
      (click)="tutorialClick(14)"
    ></div>
    <div
      class="both tutorialbutton15 tutorial"
      (click)="tutorialClick(15)"
    ></div>
    <div
      class="both tutorialbutton16 tutorial"
      (click)="tutorialClick(16)"
    ></div>
    <div
      class="both tutorialbutton17 tutorial"
      (click)="tutorialClick(17)"
    ></div>
    <div
      class="both tutorialbutton18 tutorial"
      (click)="tutorialClick(18)"
    ></div>
  </div>
  <!-- tutorial buttons-->
  <div class="translate-top-most" [resizeDom]="helpContentStage">
    <img
      class="both hometutorial button"
      src="assets/images/lobby_sprite_images/common/menu_sprite_images/tutorial_home.webp"
      (click)="buttonClick('home')"
    />
    <img
      class="both lefttutorial button"
      src="assets/images/lobby_sprite_images/common/menu_sprite_images/left.webp"
      (click)="buttonClick('left')"
    />
    <img
      class="both righttutorial button"
      src="assets/images/lobby_sprite_images/common/menu_sprite_images/right.webp"
      (click)="buttonClick('right')"
    />
  </div>
  <img
    [resizeDom]="helpCloseStage"
    class="both button translate-top-most"
    src="assets/images/lobby_sprite_images/common/menu_sprite_images/close.webp"
    (click)="buttonClick('close')"
  />
</pinch-zoom>
